// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cookie[data-v-71ed47b4]{z-index:40;background-color:hsla(0,0%,100%,.85)}@media(min-width:768px){.cookie[data-v-71ed47b4]{bottom:40px;right:10%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
